export interface LeaveScheduleWindow {
  start_date: string;
  end_date: string;
}

function toISODate(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function getLeaveScheduleWindow(baseDate: Date = new Date()): LeaveScheduleWindow {
  const start = new Date(baseDate.getFullYear(), baseDate.getMonth() - 3, 1);
  const end = new Date(baseDate.getFullYear(), baseDate.getMonth() + 4, 0);

  return {
    start_date: toISODate(start),
    end_date: toISODate(end),
  };
}
